// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CountdownTimer_wrapper__2pzlr","isTimeUp":"CountdownTimer_isTimeUp__18DA_","clockIcon":"CountdownTimer_clockIcon__1u5Cm","timer":"CountdownTimer_timer__GlXKv"};